import { NotContainsUppercaseError } from '../../validation/errors/not-contains-uppercase-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'

export class ContainsUppercaseValidation implements FieldValidation {
  readonly field: string

  constructor (field: string) {
    this.field = field
  }

  validate (value: string): Error | null {
    if (value.length === 0) return null
    if (!value.match(/[A-Z]/g)) return new NotContainsUppercaseError()
    return null
  }
}
